// Libs
import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { searchClickEvent, historyClickEvent, enterPackageIdEvent, enterPackageNameEvent } from '../../lib/analytics';

// Components
import PackageNameInput from '../../components/package-name-input';
import SearchInput from '../../components/search-input/search-input';
import List from '../../components/list/list';

// Contexts
import { StateContext } from '../../contexts/state';

// Templates
import View from '../../templates/view';

import './home.scss';

const HomeView = () => {
	const [packageName, setPackageName] = useState('');
	const [trackingNumber, setTrackingNumber] = useState('');
	const [loggedId, setLoggedId] = useState(false);
	const [loggedName, setLoggedName] = useState(false);
	const state = useContext(StateContext);
	const history = useHistory();

	function fetch({ title, code }) {
		state.fetchByCode({ title, code });
		history.push({
			pathname: `/track/${code}`,
			state: {
				title
			}
		});
	}

	function onSearchClick() {
		fetch({ title: packageName, code: trackingNumber });
		searchClickEvent();
	}

	function onHistoryClick(item) {
		fetch({ title: item.title, code: item.code });
		historyClickEvent();
	}

	useEffect(() => {
		if (trackingNumber?.length > 0 && !loggedId) {
			enterPackageIdEvent();
			setLoggedId(true);
		}

		if (packageName?.length > 0 && !loggedName) {
			enterPackageNameEvent();
			setLoggedName(true);
		}
	}, [trackingNumber, packageName, loggedId, loggedName]);

	return (
		<View className="home-view">
			<div className="home-view__wrapper">
				<div className="home-view__search-wrapper">
					<div className="home-view__text">
						<h1>Track packages from anywhere!</h1>
						<p>
							The easiest way to track all your shipment right from your browser with one new extension.
						</p>
						<span>Enter your package tracking code in field below:</span>
					</div>
					<SearchInput
						placeholder="Enter Tracking Number"
						value={trackingNumber}
						disabled={!trackingNumber}
						onChange={e => setTrackingNumber(e.target.value)}
						onSearch={onSearchClick}
					/>
				</div>
				<List
					// items={Object.values(state.tracked).map(item => ({ ...item, status: 'return' }))}
					items={state.tracked && Object.values(state.tracked)}
					// items={new Array(15).fill({
					// 	code: 'test',
					// 	title: 'TY1235486',
					// 	subtitle: 'In transit',
					// 	status: 'in_transit',
					// 	date: Date.now(),
					// 	lastTimeFetched: Date.now(),
					// })}
					badgeIds={state.badgeIds}
					onRemove={item => state.removeTrackingItem(item.code)}
					onClick={onHistoryClick}
				/>
			</div>
		</View>
	);
};

export default HomeView;
